// src/components/classroom/StudentCard.jsx
import styles from './StudentCard.module.css';

const StudentCard = ({ student, onView, onQuickLog, onDelete, selected }) => {
    // Safe extraction of name fields
    const first = student.first_name ?? student.firstName ?? "";
    const last = student.last_name ?? student.lastName ?? "";
    const fullName = `${first} ${last}`.trim();

    return (
        <div 
            className={`${styles.card} ${selected ? styles.selected : ""}`}
            role="button"
            tabIndex={0}
            onClick={() => onView(student)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onView(student);
                }
            }}
        >
            
            {/* Header */}
            <div className={styles.header}>
                <div>
                    <h3 
                        className={`${styles.name} ${styles.truncate}`} 
                        title={fullName || "Unnamed Student"}
                    >
                        {fullName || "Unnamed Student"}
                    </h3>
                    {/* <p className={styles.meta}>ID: {student._id}</p> */}
                </div>

                {/* Status indicator */}
                {student.status && (
                    <span className={`${styles.statusDot} ${styles[student.status]}`} />
                )}
            </div>

            {/* Action Buttons */}
            <div className={styles.actions}>
                <button 
                    onClick={(e) => {
                        e.stopPropagation();
                        onView(student)
                    }} 
                    className={`${styles.actionButton} ${styles.view}`}
                >
                    View Details
                </button>

                <button 
                    onClick={(e) => {
                        e.stopPropagation();
                        onQuickLog(student)
                    }} 
                    className={`${styles.actionButton} ${styles.quickLog}`}
                >
                    Quick Log
                </button>

                {onDelete && (
                    <button 
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete(student._id)
                        }} 
                        className={`${styles.actionButton} ${styles.delete}`}
                    >
                        Remove
                    </button>
                )}
            </div>
        </div>
    );
};

export default StudentCard;
